const data = [
  {
    id: 2,
    name: localStorage.getItem("local") === "cn" ? "通话记录" : "Call Log",
    icon: "PieChartOutlined",
    url_sign: "/call_log",
    path: "call_log",
    is_display: 1,
    child: [
      {
        id: 18,
        name: localStorage.getItem("local") === "cn" ? "通话列表" : "Call list",
        icon: null,
        path: "call_log/call_list",
        url_sign: "/call_log/call_list",
        is_display: 1,
      },
    ],

  },
  {
    id: 3,
    name: localStorage.getItem("local") === "cn" ? "呼叫列表" : "Dial List",
    icon: "PhoneOutlined",
    url_sign: "/dial_list",
    path: "dial_list",
    is_display: 1,
    child: [
      {
        id: 18,
        name: localStorage.getItem("local") === "cn" ? "呼叫列表" : "Dial list",
        icon: null,
        path: "dial_list/phone_list",
        url_sign: "/dial_list/phone_list",
        is_display: 1,
      },
    ],

  },
  {
    id: 4,
    name: localStorage.getItem("local") === "cn" ? "预测式外呼" : "Predictive Call",
    icon: "ScheduleOutlined",
    url_sign: "/predictiveCall",
    path: "predictiveCall",
    is_display: 1,
    child: [
      {
        id: 18,
        name: localStorage.getItem("local") === "cn" ? "预测式外呼" : "Predictive Call",
        icon: null,
        path: "predictiveCall/task_list",
        url_sign: "/predictiveCall/task_list",
        is_display: 1,
      },
    ],

  },


];
export { data };
